export default {
    name: 'subscription_usage',
    definition: {
        allowed_usage: '',
        used_units: '',
        planned_units: '',
        remaining_units: '',
    },
};
